import AccountDisplay from './AccountDisplay';

/**
 * Renders a loading skeleton for account displays
 * @param {Object} props - Component props
 * @param {string} [props.prefix] - The prefix to display before the account name
 * @returns {JSX.Element} The rendered loading account display
 */
const LoadingAccountDisplay = ({ prefix }) => (
    <AccountDisplay icon='' title='' subtitle='' prefix={prefix} loading />
);

export default LoadingAccountDisplay;
